// Video Size
function enableRatioChecker () {
  function check16by9 () {
    const videoElements = document.querySelectorAll('.swiper-slide video')

    if (videoElements.length === 0) return

    videoElements.forEach(function (video) {
      if (video.offsetWidth / video.offsetHeight >= 16 / 9) {
        video.classList.add('ratio16by9')
      } else {
        video.classList.remove('ratio16by9')
      }
    })
  }

  window.addEventListener('resize', function () {
    check16by9()
  })

  check16by9()
}

document.addEventListener('DOMContentLoaded', function () {
  enableRatioChecker()
})

// UO-Accessibility
import UoAccessability from './modules/uo-accessibility/uo-accessibility'

document.addEventListener('DOMContentLoaded', function () {
  const uoAccessability = new UoAccessability({
    overwriteFocusVisibleStyles: true,
    hiddenClass: 'visually-hidden', // BS >= 5: visually-hidden, BS < 5: sr-only
    helper: [
      {
        helperName: {
          'de-DE': 'Hauptnavigation',
          'en-EN': 'Main menu'
        },
        targetSelector: 'header .navbar-toggler',
        anchorID: 'uo-target-nav',
        linkText: {
          'de-DE': 'Direkt zur Hauptnavigation',
          'en-EN': 'Skip to main menu'
        }
      },
      {
        helperName: {
          'de-DE': 'Inhalt',
          'en-EN': 'Content'
        },
        targetSelector: 'main',
        anchorID: 'uo-target-content',
        linkText: {
          'de-DE': 'Direkt zum Inhalt',
          'en-EN': 'Skip to content'
        }
      },
      {
        helperName: {
          'de-DE': 'Footer',
          'en-EN': 'Footer'
        },
        targetSelector: 'footer',
        anchorID: 'uo-target-footer',
        linkText: {
          'de-DE': 'Direkt zum Footer',
          'en-EN': 'Skip to footer'
        }
      }
    ]
  })
})

// Sticky Navbar
function initStickyNavbar () {
  const nav = document.querySelector('nav')
  const header = document.querySelector('header')

  if (!nav || !header) return

  const isSticky = window.getComputedStyle(nav).position === 'sticky'
  const headerHeight = header.offsetHeight
  let latestKnownScrollY = 0,
    ticking = false,
    isDone = false

  const update = function () {
    const cls = nav.classList
    if (latestKnownScrollY >= headerHeight && !isDone) {
      if (!isSticky) cls.add('is-fixed') // IE11 and Edge 15
      cls.add('is-scrolled')
      isDone = true
    } else if (latestKnownScrollY < headerHeight && isDone) {
      if (!isSticky) cls.remove('is-fixed')
      cls.remove('is-scrolled')
      isDone = false
    }
    ticking = false
  }

  const onScroll = function () {
    if (window.innerWidth >= 1200) {
      latestKnownScrollY = window.pageYOffset
      if (!ticking) {
        requestAnimationFrame(update)
        ticking = true
      }
    }
  }

  if (window.innerWidth >= 1200) {
    window.addEventListener('scroll', onScroll, false)
  }
}

document.addEventListener('DOMContentLoaded', initStickyNavbar, false)

// // Datepicker
// import $ from 'jquery'
// window.$ = $

// !(function (a) {
//   a.fn.datepicker.dates.de = {
//     days: [
//       'Sonntag',
//       'Montag',
//       'Dienstag',
//       'Mittwoch',
//       'Donnerstag',
//       'Freitag',
//       'Samstag'
//     ],
//     daysShort: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
//     daysMin: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],
//     months: [
//       'Januar',
//       'Februar',
//       'März',
//       'April',
//       'Mai',
//       'Juni',
//       'Juli',
//       'August',
//       'September',
//       'Oktober',
//       'November',
//       'Dezember'
//     ],
//     monthsShort: [
//       'Jan',
//       'Feb',
//       'Mär',
//       'Apr',
//       'Mai',
//       'Jun',
//       'Jul',
//       'Aug',
//       'Sep',
//       'Okt',
//       'Nov',
//       'Dez'
//     ],
//     today: 'Heute',
//     monthsTitle: 'Monate',
//     clear: 'Löschen',
//     weekStart: 1,
//     format: 'dd.mm.yyyy'
//   }
// })($)

// document.addEventListener('DOMContentLoaded', () => {
//   const datepickers = $('.datepicker')
//   if (datepickers.length > 0) {
//     datepickers.datepicker({
//       language: 'de-DE',
//       autoclose: true,
//       todayHighlight: true
//     })
//   }
// })

// IBAN
document.querySelectorAll('.iban').forEach(function (ibanInput) {
  ibanInput.addEventListener('input', function (e) {
    e.target.value = e.target.value
      .replace(/[^\dA-Z]/g, '')
      .replace(/(.{4})/g, '$1 ')
      .trim()
  })
})

// Slider Buttons Position START

function adjustSliderButtons () {
  const firstImage = document.querySelector('.event-swiper .swiper-slide img')
  if (window.innerWidth <= 992 && firstImage) {
    const imageHeight = firstImage.clientHeight

    const prevButton = document.querySelector(
      '.event-swiper .swiper-button-prev'
    )
    const nextButton = document.querySelector(
      '.event-swiper .swiper-button-next'
    )

    if (prevButton && nextButton) {
      const buttonTop = imageHeight / 2
      prevButton.style.top = `${buttonTop}px`
      nextButton.style.top = `${buttonTop}px`
    }
  } else {
    const prevButton = document.querySelector(
      '.event-swiper .swiper-button-prev'
    )
    const nextButton = document.querySelector(
      '.event-swiper .swiper-button-next'
    )

    if (prevButton && nextButton) {
      prevButton.style.top = ''
      nextButton.style.top = ''
    }
  }
}

window.addEventListener('load', adjustSliderButtons)
window.addEventListener('resize', adjustSliderButtons)

// Slider Buttons Position END

// matchHeight START
function matchIt (element) {
  let matches = document.querySelectorAll(element)
  let rows = []

  matches.forEach(function (match) {
    match.style.height = 'auto' // Zurücksetzen der Höhe vor der Neuberechnung
    match.dataset.offset =
      'offset-' + parseInt(match.getBoundingClientRect().top)
    let batch = document.querySelectorAll(
      "[data-offset='offset-" +
        parseInt(match.getBoundingClientRect().top) +
        "']"
    )
    if (batch.length) {
      let maxH = 0
      batch.forEach(function (item) {
        if (maxH < item.clientHeight) {
          maxH = item.clientHeight
        }
      })
      batch.forEach(function (item) {
        item.style.height = maxH + 'px' // Maximale Höhe für jedes Element setzen
      })
    }
  })
  matches.forEach(function (match) {
    match.removeAttribute('data-offset') // Entfernen des data-Offsets nach der Berechnung
  })
}

function matchItAll (element) {
  // Initiale Berechnung nur wenn der Bildschirm kleiner als 992px ist
  if (window.innerWidth < 992) {
    matchIt(element)
  }

  let previousWidth = window.innerWidth

  window.addEventListener('resize', function () {
    let currentWidth = window.innerWidth

    // Wenn von > 992px auf < 992px gewechselt wird, Höhen neu berechnen
    if (previousWidth >= 992 && currentWidth < 992) {
      matchIt(element)
    } else if (previousWidth < 992 && currentWidth >= 992) {
      // Wenn von < 992px auf > 992px gewechselt wird, zurücksetzen
      let matches = document.querySelectorAll(element)
      matches.forEach(function (match) {
        match.style.height = '100%' // Höhe zurücksetzen
      })
    }

    // Überprüfen, ob der Bildschirm wirklich eine Schwelle überschreitet (genauere Berechnung)
    if (previousWidth !== currentWidth) {
      // requestAnimationFrame wird verwendet, um das Layout nach der Resize-Änderung zu aktualisieren
      requestAnimationFrame(function () {
        if (currentWidth < 992) {
          matchIt(element) // Berechnung erneut durchführen
        }
      })
    }

    previousWidth = currentWidth // Speichern der aktuellen Fenstergröße
  })
}

// Überprüfen, ob .project-swiper vorhanden ist, und dann die matchItAll-Funktion aufrufen
let projectSwipers = document.querySelectorAll('.project-swiper')
if (projectSwipers.length > 0) {
  projectSwipers.forEach(function (swiper) {
    matchItAll('.project-swiper .match-height')
  })
}

// matchHeight END

// Header Height Start

function adjustHeroHeight () {
  const header = document.querySelector('header')
  const heroSwiper = document.querySelector('.event-swiper')
  if (!heroSwiper) return;
  if (window.innerWidth >= 1200) {
    if (header && heroSwiper) {
      const headerHeight = header.offsetHeight
      const viewportHeight = window.innerHeight

      const swiperHeight = viewportHeight - headerHeight
      heroSwiper.style.height = `${swiperHeight}px`
    }
  } else {
    heroSwiper.style.height = `100%`
  }
}

window.addEventListener('load', adjustHeroHeight)
window.addEventListener('resize', adjustHeroHeight)

// Header Height END


// Toggle Form Previous Funding with Radio Buttons START
document.addEventListener('DOMContentLoaded', function () {
  // Alle Container mit der Klasse 'toggleRadioButtons' auswählen
  const toggleGroups = document.querySelectorAll('.toggleRadioButtons');

  toggleGroups.forEach(group => {
      // Radiobuttons und das abhängige Fieldset innerhalb des Containers finden
      const radioYes = group.querySelector('input[type="radio"][value="ja"]');
      const radioNo = group.querySelector('input[type="radio"][value="nein"]');
      const toggleFieldset = group.querySelector('.toggleFieldset');

      // Funktion, um das Fieldset basierend auf dem Radiobutton-Zustand ein-/auszublenden
      function toggleFieldsetVisibility() {
          if (radioYes && radioYes.checked) {
              toggleFieldset.style.display = 'block';
          } else {
              toggleFieldset.style.display = 'none';
          }
      }

      // Event-Listener für die Radiobuttons hinzufügen
      if (radioYes) {
          radioYes.addEventListener('change', toggleFieldsetVisibility);
      }
      if (radioNo) {
          radioNo.addEventListener('change', toggleFieldsetVisibility);
      }

      // Initialer Zustand überprüfen
      toggleFieldsetVisibility();
  });
});

// Toggle Form Previous Funding with Radio Buttons END

const rechtsformSelect = document.getElementById('rechtsformSelect');
if (rechtsformSelect) {
    rechtsformSelect.addEventListener('change', function () {
        const wrapper = document.getElementById('zuschussStiftungWrapper');
        if (wrapper) {
            if (this.value === '4') { // Sonstige
                wrapper.classList.remove('d-none');
            } else {
                wrapper.classList.add('d-none');
            }
        }
    });
} 
